var _text, _text2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 200,
    viewBox: "0 0 800 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 120,
    fontFamily: "Arial, sans-serif",
    fontSize: 100,
    fontWeight: 900,
    fill: "white"
  }, "\n    WEBCRUX\n  ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 190,
    y: 170,
    fontFamily: "Arial, sans-serif",
    fontSize: 48,
    fontWeight: 600,
    fill: "white",
    letterSpacing: 5
  }, "\n    TECHNOLOGY\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(600, 40)",
    fill: "none",
    stroke: "white",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 80,
    width: 40,
    height: 50,
    stroke: "white",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 50,
    width: 30,
    height: 40,
    rx: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 35,
    r: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: 60,
    x2: 10,
    y2: 70
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55,
    y1: 60,
    x2: 70,
    y2: 70
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(80, 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 40,
    width: 30,
    height: 60,
    rx: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 25,
    r: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: 50,
    x2: 10,
    y2: 60
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55,
    y1: 50,
    x2: 70,
    y2: 40
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 15 L55 15 L40 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(140, 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 80,
    width: 60,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 50,
    width: 40,
    height: 30
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 35,
    r: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 50,
    width: 20,
    height: 40,
    rx: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(160, 90)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5 -10 15 -15 20 -5 C25 -15 35 -10 40 0",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 0,
    width: 10,
    height: 15
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b8383965adacc0967fcc734f10e54427.svg";
export { ForwardRef as ReactComponent };